<template>
  <article v-if="visible">
    <div
      :class="['wrap-ad wrap-carbon-ad card', { 'with-close': withClose }]"
      :style="[hasMargin ? { '--card-margin-bottom': `${marginValue}` } : { '--card-margin-bottom': 'margin-bottom-0' }]"
    >
      <div
        ref="adTarget"
        class="carbon-ad text-center size-sm"
      ></div>
      <span class="sr-only">Advertisement</span>

      <button
        v-if="withClose"
        type="button"
        aria-label="Remove Ad"
        data-balloon-pos="left"
        class="close"
        style="--with-close-close-color: var(--fa-dk-violet)"
        @click.prevent="showRemoveAdsModal"
      >
        <font-awesome-icon :icon="$v6.duotone.faCircleXmark" />
      </button>
    </div>

    <wa-modal-upsell
      :is-showing="isShowingRemoveAdsModal"
      upsell-requirement="Pro plan"
      upsell-trigger="Removing all third-party advertisements"
      upsell-trigger-icon-name="faBillboard"
      @close-modal="hideRemoveAdsModal"
    />
  </article>
</template>

<script>
  import { EventTrackingMixin } from 'app/mixins'
  import { getAdvertisingPreferences } from 'app/store/modules/cookiePreferences'

  export default {
    name: 'CarbonAd',

    mixins: [EventTrackingMixin],

    props: {
      hasMargin: {
        type: Boolean,
        default: false
      },

      marginValue: {
        type: String,
        default: 'var(--spacing-3xl)'
      },

      withClose: {
        type: Boolean,
        default: true
      }
    },

    data() {
      return {
        isShowingRemoveAdsModal: false,
        visible: true
      }
    },

    created() {
      this.visible = this.$marketing.showAdvertising
    },

    mounted() {
      if (this.visible && document.getElementById('_carbonads_js') === null) {
        const script = document.createElement('script')

        script.setAttribute('async', '')
        script.setAttribute('id', '_carbonads_js')
        script.setAttribute('type', 'text/javascript')
        if (getAdvertisingPreferences()) {
          script.setAttribute('src', '//cdn.carbonads.com/carbon.js?serve=CKYIV5QM&placement=fontawesomecom')
        } else {
          script.setAttribute('src', '//cdn.carbonads.com/carbon.js?serve=CWYIK2QL&placement=fontawesomecom')
        }

        this.$refs.adTarget.appendChild(script)
      }
    },

    methods: {
      showRemoveAdsModal() {
        const skipModal = this.$posthog.getFeatureFlag('skip-pro-modal-go-to-plans-pro') === 'skip-modal'

        this.purchaseFlowEvent('upsell_click')

        if (skipModal) {
          window.location.replace('/plans/pro')
        } else {
          this.purchaseFlowEvent('remove_ads_modal_view', {
            context: 'carbon_ad'
          })
          this.isShowingRemoveAdsModal = true
        }
      },

      hideRemoveAdsModal() {
        this.isShowingRemoveAdsModal = false
      }
    }
  }
</script>
